import React, { useState, useEffect } from "react";
import { supabase } from "../utils/supabaseClient";

function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const isPhone = useMediaQuery('(max-width: 640px)');

  const colors = {
    bg: '#121212',
    card: '#1b1b1b',
    button: '#2a2a2a',
    border: '#3a3a3a',
    text: '#fff',
    sub: '#bbb',
  };

  const containerStyle = {
    minHeight: '100vh',
    background: colors.bg,
    color: colors.text,
    padding: isPhone ? 16 : 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 'calc(24px + env(safe-area-inset-bottom, 0))',
  };

  const cardStyle = {
    width: '100%',
    maxWidth: isPhone ? 420 : 440,
    background: colors.card,
    border: `1px solid ${colors.border}`,
    borderRadius: 12,
    boxShadow: '0 1px 0 rgba(255,255,255,0.04)',
    padding: isPhone ? 16 : 20,
    overflow: 'hidden',
  };

  // NEW: center a slightly narrower column for controls on larger screens
  const innerStyle = {
    maxWidth: isPhone ? '100%' : 360,
    margin: '0 auto',
  };

  const h1Style = {
    margin: '0 0 12px',
    fontSize: isPhone ? 22 : 26,
    textAlign: 'center',
  };

  const inputStyle = {
    width: '100%',
    boxSizing: 'border-box',
    padding: 12,
    background: '#121212',
    color: colors.text,
    border: `1px solid ${colors.border}`,
    borderRadius: 10,
    outline: 'none',
  };

  const primaryBtn = {
    width: '100%',
    boxSizing: 'border-box',
    padding: 12,
    background: colors.button,
    color: colors.text,
    border: `1px solid ${colors.border}`,
    borderRadius: 10,
    cursor: 'pointer',
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setMsg("");
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (error) setMsg(error.message);
    else setMsg("Password updated successfully. You can now sign in.");
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h1 style={h1Style}>Reset password</h1>
        <div style={innerStyle}>
          <form onSubmit={handleUpdate} style={{ display: 'grid', gap: 10 }}>
            <div>
              <label htmlFor="new-pass" style={{ display: 'block', marginBottom: 6, color: colors.sub, fontSize: 13 }}>
                New password
              </label>
              <input
                id="new-pass"
                type="password"
                placeholder="Enter a new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={inputStyle}
                autoComplete="new-password"
                required
              />
            </div>
            <button type="submit" style={primaryBtn} disabled={loading}>
              {loading ? 'Updating…' : 'Update password'}
            </button>
          </form>
          {msg && <p style={{ marginTop: 10, color: '#ccc', textAlign: 'center' }}>{msg}</p>}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
